import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from "react";

import AtlLayout from "brands/atlantic/layout";
import { Outlet } from "react-router";
import { Maintenance } from "components/Maintenance";
import useMaintenance from "utils/hooks/useMaintenance";
import useTranslation from "utils/hooks/useTranslation";
import Loader from "components/shared/loader";
import * as yup from "yup";

const Layout: React.FC<PropsWithChildren<{ hasBrandLayout?: boolean }>> = ({
  hasBrandLayout = true,
}) => {
  const [isMount, setIsMount] = useState(false);
  const { isInMaintenance, setIsInMaintenance } = useMaintenance();
  const { translations, t } = useTranslation();

  const BrandLayout = AtlLayout;

  const setLocale = useCallback(() => {
    yup.addMethod(yup.string, "notLongWord", function () {
      return this.test("not-long-word", function (value) {
        const maxChar = 30;
        const chunks = value?.split(" ");
        const isLongWord = chunks?.some((chunk) => chunk.length > maxChar);

        if (isLongWord) {
          throw this.createError({
            message: `This field contains more than ${maxChar} characters without space.`,
          });
        }

        return true;
      });
    });
  }, [t]);

  useEffect(() => {
    //dispatch(setCurrentLanguage(lang!));
    setIsMount(true);
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setLocale();
  }, [setLocale]);

  return translations ? (
    isInMaintenance ? (
      <Maintenance setIsInMaintenance={setIsInMaintenance} />
    ) : isMount ? (
      <BrandLayout simple={!hasBrandLayout}>
        <Outlet />
      </BrandLayout>
    ) : (
      <></>
    )
  ) : (
    <Loader />
  );
};

export default Layout;
